import type { AllRouteEndpoints } from "../routeTypes";
export const internalUserGroupsInternalUserGroupUpdateCacheKeys: AllRouteEndpoints[] = [
  "/internal_user_groups/:internal_user_group_id",
  "/internal_user_groups/internal_user_groups_data",
  "/internal_user_groups/internal_user_groups_data_v2",
];
